module.exports = __webpack_public_path__ + "static/media/logo-create.d771862f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-create.png
// module id = 836
// module chunks = 0